import {AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn} from '@angular/forms';

export class CustomValidators {
  static dateInFuture(formControl: FormControl<Date>) {
    if (formControl?.value == null) {
      return null;
    }
    if (new Date() > new Date(formControl.value)) {
      return {futureDate: {value: formControl.value}};
    }
    return null;
  }

  static notOnlyWhitespace(c: FormControl<string>) {
    if (c?.value == null || c.value == '') {
      return null;
    }
    if (c.value.trim().length === 0) {
      return {whitespace: {}};
    }
    return null;
  }


  public static validNumber({allowZero = false, isInteger = false}:
                              { allowZero?: boolean; isInteger?: boolean; }
                              = {}): ValidatorFn {
    return (control: FormControl) => {
      if ((control?.dirty || control?.touched) && (control.value == null || control.value === '')) {
        return null;
      }
      let value = +control.value;

      if (isNaN(value)) {
        return {number: {}};
      }
      if (value < 0.009 && !allowZero || value < 0) {
        return {positive: {}};
      }
      if (isInteger && !Number.isInteger(value)) {
        return {integer: {}};
      }
      return null;
    };

  }


  public static firstDataBeforeSecond(firstDateName: string, secondDateName: string): ValidatorFn {
    return (formGroup: FormGroup) => {

      const firstDateControl = formGroup.get(firstDateName);
      const secondDateControl = formGroup.get(secondDateName);

      if (!firstDateControl.dirty || !secondDateControl.dirty) {
        return null;
      }
      const firstDate = new Date(firstDateControl.value);
      const secondDate = new Date(secondDateControl.value);

      if (firstDate > secondDate) {
        return {dateBefore: {}};
      }
    };
  }

  static atLeastOneTrue(
    controlName1: string,
    controlName2: string
  ): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const c1 = group.get(controlName1)?.value;
      const c2 = group.get(controlName2)?.value;

      return c1 || c2 ? null : { atLeastOneRequired: true };
    };
  }

}
